export default "/img/DZ.be5c5e2bfec41b5e89b6bfca7e82bd4e.png";